"use client";

import { useEffect } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useUserStore, useHydrated } from "@/store/userStore";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const user = useUserStore((s) => s.user);
  const hydrated = useHydrated();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (hydrated && !user) {
      localStorage.setItem("redirectAfterLogin", pathname);
      router.replace("/");
    }
  }, [hydrated, user, router, pathname]);

  if (!hydrated || !user) return null;

  return <>{children}</>;
}
